"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayswappersWithMigrationFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var DayswappersWithMigrationFactory = /** @class */ (function (_super) {
    __extends(DayswappersWithMigrationFactory, _super);
    function DayswappersWithMigrationFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    DayswappersWithMigrationFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    DayswappersWithMigrationFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    DayswappersWithMigrationFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    DayswappersWithMigrationFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    DayswappersWithMigrationFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return DayswappersWithMigrationFactory;
}(contracts_1.ContractFactory));
exports.DayswappersWithMigrationFactory = DayswappersWithMigrationFactory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint32',
                name: 'seatIndex',
                type: 'uint32',
            },
            {
                indexed: true,
                internalType: 'uint32',
                name: 'month',
                type: 'uint32',
            },
        ],
        name: 'Active',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'wallet',
                type: 'bytes32',
            },
            {
                indexed: false,
                internalType: 'bool',
                name: 'newStatus',
                type: 'bool',
            },
        ],
        name: 'Authorised',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint32',
                name: 'introducerSeatIndex',
                type: 'uint32',
            },
            {
                indexed: true,
                internalType: 'uint32',
                name: 'networkerSeatIndex',
                type: 'uint32',
            },
        ],
        name: 'Introduce',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint32',
                name: 'seatIndex',
                type: 'uint32',
            },
        ],
        name: 'KycResolve',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint32',
                name: 'month',
                type: 'uint32',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'sender',
                type: 'address',
            },
        ],
        name: 'NRTReceived',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint32',
                name: 'seatIndex',
                type: 'uint32',
            },
            {
                indexed: true,
                internalType: 'uint32',
                name: 'beltIndex',
                type: 'uint32',
            },
        ],
        name: 'Promotion',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'platform',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint32',
                name: 'seatIndex',
                type: 'uint32',
            },
            {
                indexed: true,
                internalType: 'uint32',
                name: 'month',
                type: 'uint32',
            },
            {
                indexed: false,
                internalType: 'bool',
                name: 'isDefinite',
                type: 'bool',
            },
            {
                indexed: false,
                internalType: 'bool',
                name: 'fromTree',
                type: 'bool',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'reward',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256[3]',
                name: 'rewardRatio',
                type: 'uint256[3]',
            },
        ],
        name: 'Reward',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint32',
                name: 'seatIndex',
                type: 'uint32',
            },
        ],
        name: 'SeatTransfer',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'platform',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint32',
                name: 'seatIndex',
                type: 'uint32',
            },
            {
                indexed: true,
                internalType: 'uint32',
                name: 'month',
                type: 'uint32',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'Volume',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint32',
                name: 'seatIndex',
                type: 'uint32',
            },
            {
                indexed: true,
                internalType: 'bool',
                name: 'isDefinite',
                type: 'bool',
            },
            {
                indexed: false,
                internalType: 'enum IDayswappers.RewardType',
                name: 'rewardType',
                type: 'uint8',
            },
            {
                indexed: false,
                internalType: 'uint32',
                name: 'month',
                type: 'uint32',
            },
            {
                indexed: false,
                internalType: 'uint256[3]',
                name: 'adjustedRewards',
                type: 'uint256[3]',
            },
        ],
        name: 'Withdraw',
        type: 'event',
    },
    {
        inputs: [],
        name: 'dayswappers',
        outputs: [
            {
                internalType: 'contract IDayswappers',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: 'treeReferrals',
                type: 'uint32',
            },
        ],
        name: 'getBeltIdFromTreeReferrals',
        outputs: [
            {
                internalType: 'uint32',
                name: '_newBeltIndex',
                type: 'uint32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
        ],
        name: 'getMonthlyNRT',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_networker',
                type: 'address',
            },
        ],
        name: 'getSeatByAddress',
        outputs: [
            {
                internalType: 'uint32',
                name: 'seatIndex',
                type: 'uint32',
            },
            {
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                internalType: 'bool',
                name: 'kycResolved',
                type: 'bool',
            },
            {
                internalType: 'uint32',
                name: 'incompleteKycResolveSeatIndex',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: 'depth',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: 'introducerSeatIndex',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: 'beltIndex',
                type: 'uint32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_networker',
                type: 'address',
            },
        ],
        name: 'getSeatByAddressStrict',
        outputs: [
            {
                internalType: 'uint32',
                name: 'seatIndex',
                type: 'uint32',
            },
            {
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                internalType: 'bool',
                name: 'kycResolved',
                type: 'bool',
            },
            {
                internalType: 'uint32',
                name: 'incompleteKycResolveSeatIndex',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: 'depth',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: 'introducerSeatIndex',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: 'beltIndex',
                type: 'uint32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_seatIndex',
                type: 'uint32',
            },
        ],
        name: 'getSeatByIndex',
        outputs: [
            {
                internalType: 'uint32',
                name: 'seatIndex',
                type: 'uint32',
            },
            {
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                internalType: 'bool',
                name: 'kycResolved',
                type: 'bool',
            },
            {
                internalType: 'uint32',
                name: 'incompleteKycResolveSeatIndex',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: 'depth',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: 'introducerSeatIndex',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: 'beltIndex',
                type: 'uint32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_networker',
                type: 'address',
            },
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
        ],
        name: 'getSeatMonthlyDataByAddress',
        outputs: [
            {
                internalType: 'uint32',
                name: 'treeReferrals',
                type: 'uint32',
            },
            {
                internalType: 'uint256',
                name: 'volume',
                type: 'uint256',
            },
            {
                internalType: 'uint256[3]',
                name: 'definiteEarnings',
                type: 'uint256[3]',
            },
            {
                internalType: 'uint256[3]',
                name: 'nrtEarnings',
                type: 'uint256[3]',
            },
            {
                internalType: 'bool',
                name: 'isActive',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_networker',
                type: 'address',
            },
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
        ],
        name: 'getSeatMonthlyDataByAddressStrict',
        outputs: [
            {
                internalType: 'uint32',
                name: 'treeReferrals',
                type: 'uint32',
            },
            {
                internalType: 'uint256',
                name: 'volume',
                type: 'uint256',
            },
            {
                internalType: 'uint256[3]',
                name: 'definiteEarnings',
                type: 'uint256[3]',
            },
            {
                internalType: 'uint256[3]',
                name: 'nrtEarnings',
                type: 'uint256[3]',
            },
            {
                internalType: 'bool',
                name: 'isActive',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_seatIndex',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
        ],
        name: 'getSeatMonthlyDataByIndex',
        outputs: [
            {
                internalType: 'uint32',
                name: 'treeReferrals',
                type: 'uint32',
            },
            {
                internalType: 'uint256',
                name: 'volume',
                type: 'uint256',
            },
            {
                internalType: 'uint256[3]',
                name: 'definiteEarnings',
                type: 'uint256[3]',
            },
            {
                internalType: 'uint256[3]',
                name: 'nrtEarnings',
                type: 'uint256[3]',
            },
            {
                internalType: 'bool',
                name: 'isActive',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
        ],
        name: 'getTotalMonthlyActiveDayswappers',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
        ],
        name: 'getTotalMonthlyIndefiniteRewards',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: 'uint32',
                        name: 'required',
                        type: 'uint32',
                    },
                    {
                        internalType: 'uint256',
                        name: 'distributionPercent',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'leadershipPercent',
                        type: 'uint256',
                    },
                ],
                internalType: 'struct Dayswappers.Belt[]',
                name: '_belts',
                type: 'tuple[]',
            },
        ],
        name: 'initialize',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_networker',
                type: 'address',
            },
        ],
        name: 'isActiveAddress',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_seatIndex',
                type: 'uint32',
            },
        ],
        name: 'isActiveSeat',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'isAdminMode',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '_username',
                type: 'bytes32',
            },
        ],
        name: 'isAuthorized',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_wallet',
                type: 'address',
            },
        ],
        name: 'isAuthorized',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_networker',
                type: 'address',
            },
        ],
        name: 'isJoined',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_introducer',
                type: 'address',
            },
        ],
        name: 'join',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'kycDapp',
        outputs: [
            {
                internalType: 'contract IKycDapp',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: 'address',
                        name: 'owner',
                        type: 'address',
                    },
                    {
                        internalType: 'bool',
                        name: 'kycResolved',
                        type: 'bool',
                    },
                    {
                        internalType: 'uint32',
                        name: 'incompleteKycResolveSeatIndex',
                        type: 'uint32',
                    },
                    {
                        internalType: 'uint32',
                        name: 'depth',
                        type: 'uint32',
                    },
                    {
                        internalType: 'address',
                        name: 'introducer',
                        type: 'address',
                    },
                    {
                        internalType: 'uint32',
                        name: 'beltIndex',
                        type: 'uint32',
                    },
                ],
                internalType: 'struct DayswappersWithMigration.SeatInput[]',
                name: '_seats',
                type: 'tuple[]',
            },
        ],
        name: 'migrateSeats',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'nrtManager',
        outputs: [
            {
                internalType: 'contract INRTManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_networker',
                type: 'address',
            },
            {
                internalType: 'uint256[3]',
                name: '_rewardRatio',
                type: 'uint256[3]',
            },
        ],
        name: 'payToIntroducer',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_networker',
                type: 'address',
            },
            {
                internalType: 'uint256[3]',
                name: '_rewardRatio',
                type: 'uint256[3]',
            },
        ],
        name: 'payToNetworker',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_networker',
                type: 'address',
            },
            {
                internalType: 'uint256[3]',
                name: '_rewardRatio',
                type: 'uint256[3]',
            },
        ],
        name: 'payToTree',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'prepaidEs',
        outputs: [
            {
                internalType: 'contract IPrepaidEs',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_networker',
                type: 'address',
            },
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
        ],
        name: 'promoteBelt',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'randomnessManager',
        outputs: [
            {
                internalType: 'contract RandomnessManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_currentNrtMonth',
                type: 'uint32',
            },
        ],
        name: 'receiveNrt',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'renounceAdminMode',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_networker',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_amount',
                type: 'uint256',
            },
        ],
        name: 'reportVolume',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '_username',
                type: 'bytes32',
            },
        ],
        name: 'resolveAddress',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '_username',
                type: 'bytes32',
            },
        ],
        name: 'resolveAddressStrict',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_networker',
                type: 'address',
            },
        ],
        name: 'resolveIntroducer',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_networker',
                type: 'address',
            },
        ],
        name: 'resolveKyc',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_wallet',
                type: 'address',
            },
        ],
        name: 'resolveUsername',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_wallet',
                type: 'address',
            },
        ],
        name: 'resolveUsernameStrict',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_networker',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_value',
                type: 'uint256',
            },
            {
                internalType: 'uint256[3]',
                name: '_rewardRatio',
                type: 'uint256[3]',
            },
        ],
        name: 'rewardToTree',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_kycDapp',
                type: 'address',
            },
        ],
        name: 'setKycDapp',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_nullWallet',
                type: 'address',
            },
        ],
        name: 'setNullWallet',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_volumeTarget',
                type: 'uint256',
            },
        ],
        name: 'setVolumeTarget',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeallyClub',
        outputs: [
            {
                internalType: 'contract ITimeAllyClub',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeallyManager',
        outputs: [
            {
                internalType: 'contract ITimeAllyManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeallyPromotionalBucket',
        outputs: [
            {
                internalType: 'contract ITimeAllyPromotionalBucket',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_newOwner',
                type: 'address',
            },
        ],
        name: 'transferSeat',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '_username',
                type: 'bytes32',
            },
            {
                internalType: 'bool',
                name: '_newStatus',
                type: 'bool',
            },
        ],
        name: 'updateAuthorization',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'validatorManager',
        outputs: [
            {
                internalType: 'contract IValidatorManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'volumeTarget',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakingContract',
                type: 'address',
            },
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
            {
                internalType: 'enum IDayswappers.RewardType',
                name: '_rewardType',
                type: 'uint8',
            },
        ],
        name: 'withdrawDefiniteEarnings',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakingContract',
                type: 'address',
            },
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
            {
                internalType: 'enum IDayswappers.RewardType',
                name: '_rewardType',
                type: 'uint8',
            },
        ],
        name: 'withdrawNrtEarnings',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
];
var _bytecode = '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';
//# sourceMappingURL=DayswappersWithMigrationFactory.js.map